/* CsvImportCancelConfirmBody styles */

:host {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: var(--spacing-6);
  gap: var(--spacing-5);
  min-height: 215px;
}

/* ---------- Warning icon ----------- */

.warning-icon {
  --hcds-icon-size: 42px;
  color: var(--color-gray-900);
}

.success-icon {
  --hcds-icon-size: 42px;
  color: var(--color-green-600);
}

/* ---------- Warning message ----------- */

.warning-message {
  margin: 0;
  font-family: var(--font-sans);
  font-size: var(--text-base);
  font-weight: var(--font-weight-normal);
  color: var(--color-gray-900);
  line-height: var(--leading-snug);
  text-align: center;
  max-width: 311px;
}
